import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import { getThought } from "../Service/Api";
function ThoughtOfTheDay() {
  const [thoughts, setThoughts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    document.title =
      "Thought of the day - St Peters Convent School Faridabad Haryana";

    const fetchThoughts = async () => {
      try {
        const data = await getThought();
        setThoughts(data);
      } catch (err) {
        setError("Failed to load thoughts.");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchThoughts();
  }, []);
  if (loading) return <p>Loading thoughts...</p>;
  if (error) return <p>{error}</p>;

  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>Events</li>
          <li>Thought Of The Day</li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1>Thought Of The Day</h1>
            </div>
          </div>

          <div className="row">
            {thoughts.map((thought) => (
              <div className="col-lg-6" key={thought._id}>
                <div className="thought-wrapper-flex">
                  <div className="thought-content">
                    <h2 className="thought-title">{thought.name}</h2>
                    <p className="thought-desc">{thought.message}</p>
                    <p className="thought-date">
                      <strong>Date:</strong>
                      {new Date(thought.date)
                        .toLocaleDateString("en-GB")
                        .replaceAll("/", "-")}
                    </p>
                  </div>
                  <div className="thought-image-left">
                    {thought.images && thought.images.length > 0 ? (
                      <a
                        data-magnify="gallery"
                        data-group="a"
                        href={`https://webapi.entab.info/api/image/${thought.images[0]}`}>
                        <img
                          src={`https://webapi.entab.info/api/image/${thought.images[0]}`}
                          alt="Thought"
                        />
                      </a>
                    ) : (
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/demo.jpg"
                        alt="Thought"
                      />
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
export default ThoughtOfTheDay;
